export const DistributionUploadConfig = {
	list: 'Distribution',
	grid: {
		gridId: 'DistributionUploadGrid',
		height: 500,
		checkbox: false,
		edit: false,
		delete: true,
		sortable: false,
		pageSize: 10,
		groupable: false
	},
	columns: {
		Id: {
			class: 'id',
			dataName: 'Id',
			type: 'number',
			title: 'Id',
			width: 100,
			hidden: true,
			readOnly: false
		},
		Validation: {
			dataName: 'Validation',
			type: 'string',
			title: 'Validation',
			width: 130,
			hidden: false
		},
		PartnerId: {
			class: "lookup",
			dataName: 'PartnerId',
			type: 'number',
			title: 'Partner Id',
			width: 130,
			hidden: true,
			readOnly: false
		},
		PartnerPartnerID: {
			class: "lookup",
			dataName: 'PartnerPartnerID',
			type: 'string',
			title: 'Partner ID',
			width: 130,
			hidden: false,
			readOnly: true
		},
		PartnerTitle: {
			class: "lookup",
			dataName: 'PartnerTitle',
			type: 'string',
			title: 'Partner Name',
			width: 150,
			hidden: false,
			readOnly: true
		},
		ProgramId: {
			class: "lookup",
			dataName: 'ProgramId',
			type: 'number',
			title: 'Program Id',
			width: 150,
			hidden: true,
			readOnly: false
		},
		ProgramProgramID: {
			class: "lookup",
			dataName: 'ProgramProgramID',
			type: 'string',
			title: 'Program ID',
			width: 130,
			hidden: false,
			readOnly: true
		},
		ProgramTitle: {
			class: "lookup",
			dataName: 'ProgramTitle',
			type: 'string',
			title: 'Program',
			width: 120,
			hidden: false,
			readOnly: true
		},
		DistributionType1: {
			class: "choice",
			dataName: 'DistributionType1',
			type: 'string',
			title: 'Type of Distribution 1',
			width: 220,
			hidden: false,
			readOnly: false
		},
		DistributionType2: {
			class: "choice",
			dataName: 'DistributionType2',
			type: 'string',
			title: 'Type of Distribution 2',
			width: 220,
			hidden: false,
			readOnly: false
		},
		DistributionPartnerType: {
			class: "choice",
			dataName: 'DistributionPartnerType',
			type: 'string',
			title: 'Type of Partner',
			width: 220,
			hidden: false,
			readOnly: false
		},
		DistributionDate: {
			class: 'value',
			dataName: 'DistributionDate',
			type: 'date',
			title: 'Distribution Date',
			width: 180,
			hidden: false,
			readOnly: false
		},
		DistributionAmount: {
			class: "value",
			dataName: 'DistributionAmount',
			type: 'number',
			title: 'Distribution Amount',
			template: '#=kendo.toString(DistributionAmount, "c")#',
			width: 200,
			hidden: false,
			readOnly: false
		},
		Note: {
			class: 'value',
			dataName: 'Note',
			type: 'string',
			title: 'Note',
			width: 100,
			hidden: false,
			readOnly: false
		}
	},

}